<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
    <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
            {{ $t('ajoutDevis.popUpSelectFace.messageInstructionPose') }}
        </p>
    </section>
    <section class="mgt-10px">
        <b-field :label="$t('ajoutDevis.popUpSelectFace.tab.instructionPose')"
          class="mgt-20px obligatoire">
          <b-input v-model="instructionPose"> </b-input>
        </b-field>
    </section>
    <footer class="mgt-10px">
      <div class="has-text-centered">
        <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
        </button>
        <button class="button is-primary has-text-centered button-modal"
            @click="addInstructionsPose">
            {{ $t('general.button.valider') }}
        </button>
      </div>
    </footer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      instructionPose: null,
    };
  },
  methods: {
    addInstructionsPose() {
      this.$emit('addInstructionsPose', this.instructionPose);
    },
  },
};
</script>
